import type { Editor } from "@tiptap/react";
import { createContext, ReactNode, useContext, useState } from "react";

interface ActiveDocumentContextType {
  activeEditor: Editor | null;
  setActiveEditor: (editor: Editor | null) => void;
}

const ActiveDocumentContext = createContext<
  ActiveDocumentContextType | undefined
>(undefined);

interface ActiveDocumentProviderProps {
  children: ReactNode;
}

export function ActiveDocumentProvider({
  children,
}: ActiveDocumentProviderProps) {
  const [activeEditor, setActiveEditor] = useState<Editor | null>(null);

  const value: ActiveDocumentContextType = {
    activeEditor,
    setActiveEditor,
  };

  return (
    <ActiveDocumentContext.Provider value={value}>
      {children}
    </ActiveDocumentContext.Provider>
  );
}

export function useActiveDocument() {
  const context = useContext(ActiveDocumentContext);
  if (context === undefined) {
    throw new Error(
      "useActiveDocument must be used within an ActiveDocumentProvider",
    );
  }
  return context;
}
